import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { AuthService } from '@app/services/auth.service';
import { NotifyService } from '@app/services/notify.service';
import { TranslatableKey } from '@app/types/translatable.type';
import {
    FeedbackTypesDisplayOptions,
    FeedbackVisibilityDisplayOptions,
} from '@app/types/translatables/feedback-display.options';
import { ShowView } from '@common/views';
import { BadgeType } from '@humi-design-library/components/Badge/types';

@Component({
    templateUrl: './feedback-show.template.html',
    styleUrls: ['./feedback-show.style.scss'],
})
export class FeedbackShowView extends ShowView implements OnInit {
    @ViewChild('deleteConfirmationDialog', { static: true })
    deleteConfirmationDialog: DeprecatedConfirmationDialogComponent;
    isLoading = false;
    profile: any;
    feedback: any = {};
    userId: number | null;
    feedbackId: number;
    settings: any;
    feedbackVisibility: TranslatableKey | string;
    feedbackTypes = FeedbackTypesDisplayOptions;

    BADGE_TYPES: Partial<Record<string, BadgeType>> = {
        public: 'success',
        private: 'warning',
        manager: 'default',
        admin: 'default',
    };

    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private notify: NotifyService,
        private auth: AuthService
    ) {
        super();
        this.feedback = this.route.snapshot.data.models.get('feedback');
        this.userId = +route.snapshot.params.userId || null;
        this.feedbackId = route.snapshot.params.feedback_id;
        this.settings = this.route.snapshot.data.companySettings;
        this.feedbackVisibility =
            FeedbackVisibilityDisplayOptions[this.feedback.visibility] ?? this.feedback.visibility;
    }

    onSave(): void {}
    onCancel(): void {}
    onDelete(): void {}

    ngOnInit(): void {}

    canDelete(): boolean {
        return this.auth.isAdmin() || (this.feedback && Number(this.feedback.createdBy) === Number(this.auth.user.id));
    }

    delete(): void {
        this.deleteConfirmationDialog
            .show()
            .then((confirmDelete) => {
                if (confirmDelete) {
                    this.isLoading = true;
                    this.feedback
                        .delete()
                        .then(() => {
                            this.location.back();
                            this.notify.success('performance.feedback-show.hasBeenDeleted');
                        })
                        .catch((err) => {
                            this.notify.error(err);
                            this.isLoading = false;
                        });
                }
            })
            .catch(() => {});
    }

    getFeedbackBody(): any {
        if (this.feedback && this.feedback.body) {
            return this.feedback.body.replace(new RegExp('\n', 'g'), '<br />');
        }
    }
}
